import type { ProductEdition } from './api';

export type HosSocialChannelId = 'whatsapp';

export interface HosSocialWebPlatform {
  id: HosSocialChannelId;
  label: string;
  url: string;
  entitlement: HosSocialChannelId;
}

export interface BosSocialManagementLink {
  id: HosSocialChannelId;
  label: string;
  path: '/whatsapp';
}

export interface HosSocialPresentation {
  mode: 'standalone' | 'managed-in-bos';
  webPlatforms: HosSocialWebPlatform[];
  bosManagementLinks: BosSocialManagementLink[];
  whatsappManagementPath: '/hos/whatsapp' | '/whatsapp' | null;
}

const SOCIAL_CHANNELS = [
  {
    id: 'whatsapp',
    label: 'WhatsApp',
    url: 'https://web.whatsapp.com/',
    entitlement: 'whatsapp',
    bosPath: '/whatsapp',
  },
] as const;

export function hosWhatsappManagementPath(
  edition: ProductEdition,
): '/hos/whatsapp' | '/whatsapp' {
  return edition === 'hos' ? '/hos/whatsapp' : '/whatsapp';
}

export function getHosSocialPresentation(
  edition: ProductEdition,
  integrations: readonly string[],
): HosSocialPresentation {
  const enabled = new Set(integrations.map((integration) => integration.trim().toLowerCase()));
  const channels = SOCIAL_CHANNELS.filter((channel) => enabled.has(channel.entitlement));
  const standalone = edition === 'hos';

  return {
    mode: standalone ? 'standalone' : 'managed-in-bos',
    // LinkedIn is a BOS-only business surface. HOS Social intentionally keeps
    // only personal messaging channels such as WhatsApp.
    webPlatforms: channels.map(({ id, label, url, entitlement }) => ({ id, label, url, entitlement })),
    bosManagementLinks: standalone
      ? []
      : channels.map(({ id, label, bosPath }) => ({ id, label, path: bosPath })),
    whatsappManagementPath: enabled.has('whatsapp')
      ? hosWhatsappManagementPath(edition)
      : null,
  };
}
